<template>
  <div class="bg-white rounded-2xl shadow-lg border-2 border-psychology-secondary-20 overflow-hidden">
    <!-- 卡片头部 -->
    <div class="bg-gradient-to-r from-psychology-secondary to-psychology-accent px-6 py-4">
      <div class="flex items-center gap-3 text-white">
        <span class="text-4xl">{{ primaryTypeData.emoji }}</span>
        <div class="flex-1">
          <h3 class="text-xl font-bold">{{ primaryType }}</h3>
          <p class="text-sm opacity-90">依恋类型人格分析</p>
        </div>
      </div>
    </div>

    <!-- 卡片内容 -->
    <div class="p-6 space-y-6">
      <!-- 主导类型 -->
      <div>
        <div class="flex items-center gap-2 mb-3">
          <span class="text-2xl">{{ primaryTypeData.emoji }}</span>
          <h4 class="font-semibold text-gray-900">主导类型: {{ primaryType }}</h4>
          <span class="ml-auto px-3 py-1 bg-psychology-secondary text-white text-xs rounded-full">
            {{ primaryScore }}分
          </span>
        </div>
        <p class="text-gray-700 leading-relaxed text-sm">{{ primaryTypeData.description }}</p>
      </div>

      <!-- 次要类型 -->
      <div>
        <div class="flex items-center gap-2 mb-3">
          <span class="text-2xl">{{ secondaryTypeData.emoji }}</span>
          <h4 class="font-semibold text-gray-900">次要类型: {{ secondaryType }}</h4>
          <span class="ml-auto px-3 py-1 bg-gray-300 text-gray-700 text-xs rounded-full">
            {{ secondaryScore }}分
          </span>
        </div>
        <p class="text-gray-700 leading-relaxed text-sm">{{ secondaryTypeData.description }}</p>
      </div>

      <!-- 双类型特征 -->
      <div>
        <h4 class="font-semibold text-gray-900 mb-3 flex items-center gap-2">
          <span>✨</span>
          <span>你的依恋特征</span>
        </h4>
        <div class="grid gap-2">
          <div 
            v-for="(feature, index) in combinedFeatures" 
            :key="index"
            class="flex items-start gap-2 p-3 bg-psychology-secondary-5 rounded-lg"
          >
            <span class="text-psychology-secondary mt-0.5">•</span>
            <span class="text-gray-700 text-sm">{{ feature }}</span>
          </div>
        </div>
      </div>

      <!-- 心理学解读 -->
      <div>
        <h4 class="font-semibold text-gray-900 mb-2 flex items-center gap-2">
          <span>🧠</span>
          <span>心理学解读</span>
        </h4>
        <p class="text-gray-700 leading-relaxed text-sm bg-gray-50 p-4 rounded-lg">
          {{ primaryTypeData.psychology }}
        </p>
      </div>

      <!-- 改善建议 -->
      <div>
        <h4 class="font-semibold text-gray-900 mb-3 flex items-center gap-2">
          <span>💡</span>
          <span>关系改善建议</span>
        </h4>
        <div class="space-y-2">
          <div 
            v-for="(advice, index) in primaryTypeData.advice" 
            :key="index"
            class="flex items-start gap-2 p-3 bg-gradient-to-r from-psychology-calm to-psychology-warm rounded-lg"
          >
            <span class="text-psychology-secondary font-semibold mt-0.5">{{ index + 1 }}.</span>
            <span class="text-gray-700 text-sm">{{ advice }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ATTACHMENT_TYPES } from '@/data/personalityTypes'

export default {
  name: 'AttachmentTypeCard',
  props: {
    primaryType: {
      type: String,
      required: true
    },
    secondaryType: {
      type: String,
      required: true
    },
    primaryScore: {
      type: Number,
      default: 0
    },
    secondaryScore: {
      type: Number,
      default: 0
    }
  },
  computed: {
    primaryTypeData() {
      return ATTACHMENT_TYPES[this.primaryType] || {}
    },
    secondaryTypeData() {
      return ATTACHMENT_TYPES[this.secondaryType] || {}
    },
    combinedFeatures() {
      // 合并主导和次要类型的特征,各取前3个
      const primary = this.primaryTypeData.features?.slice(0, 3) || []
      const secondary = this.secondaryTypeData.features?.slice(0, 3) || []
      return [...primary, ...secondary]
    }
  }
}
</script>

